import { getOrdinalSuffix } from 'utils/formatting';
import { rangeWindowSize } from 'utils/dates';
export const getRangeString = (start, end) => {
    if (start === 0 || end === 0) {
        return '- and -';
    }
    if (start === end) {
        return `${start}${getOrdinalSuffix(start)}`;
    }
    if (rangeWindowSize(start, end) === 31) {
        return 'Any day';
    }
    return `${start}${getOrdinalSuffix(start)} to ${end}${getOrdinalSuffix(end)}`;
};
const calcAmount = (fromSub, fromTransaction) => {
    if (fromSub !== undefined && fromSub !== null) {
        return fromSub;
    }
    if (fromTransaction) {
        return Math.abs(fromTransaction?.nativeAmount
            ? fromTransaction.nativeAmount.amount
            : fromTransaction.amount);
    }
    return 0;
};
export const getMinAndMax = (subscription) => {
    if (!subscription) {
        return ['0', '0'];
    }
    const { minAmount, maxAmount } = subscription;
    const start = {
        nativeAmount: subscription.nativeAmount,
        amount: subscription.amount,
    };
    const minTransaction = subscription?.transactions?.reduce((a, b) => {
        if (a.nativeAmount && b.nativeAmount)
            return a.nativeAmount.amount > b.nativeAmount.amount ? a : b;
        return a.amount > b.amount ? a : b;
    }, start);
    const maxTransaction = subscription?.transactions?.reduce((a, b) => {
        if (a.nativeAmount && b.nativeAmount)
            return a.nativeAmount.amount < b.nativeAmount.amount ? a : b;
        return a.amount < b.amount ? a : b;
    }, start);
    return [
        Math.floor(calcAmount(minAmount, minTransaction)).toFixed(0),
        Math.ceil(calcAmount(maxAmount, maxTransaction)).toFixed(0),
    ];
};
